// extracted by mini-css-extract-plugin
export var label = "_ez-5";
export var slideContainer = "_ez-0";
export var slider = "_ez-1";
export var sliderLg = "_ez-4";
export var sliderMd = "_ez-3";
export var sliderSm = "_ez-2";